/**
 * After the first ingest, wizard Next rematerializes the mapped response
 * column (classification labels, NER entities, generative summary/output) or
 * strips classification labels — without re-uploading the file.
 */

/**
 * @param {{ hasLabels?: boolean, labelColumn?: string }} details
 * @returns {'apply' | 'clear' | 'none'}
 */
export function labelColumnSyncAction(details) {
    if (!details) return 'none';
    if (details.hasLabels === false) return 'clear';
    if (details.labelColumn) return 'apply';
    return 'none';
}
